<template>
  <div class="login-super-container">
	 <CreateNavBar />

    <div class="container">
      <loader :isLoading="isRequestInProgress"/>
      <h2 class="hero" id>Welcome Back!</h2>

      <div class="login-form">
        <form @submit.prevent="login" novalidate>
          <div class="form-group">
            <label for="email-login" class="col-form-label">Email Address</label>
            <input
              id="email-login"
              v-model="form.email_address"
              type="email"
              class="form-control"
              :disabled="autoFillEmail"
              placeholder="you@awesome.com">
          </div>

          <div class="form-group">
            <label for="password-login" class="col-form-label">Password</label>
            <input
              id="password-login"
              v-model="form.password"
              type="password"
              class="form-control"
              :disabled="autoFillPassword"
              placeholder="Password">
          </div>

          <div class="text-center">
            <button :disabled="!hasValidInvite" type="submit" class="btn btn-primary">Submit</button>
          </div>
        </form>
      </div>

      <!-- ERROR wrong email and password -->
      <br/>

      <div class="text-center">
        <small
          data-type="message"
          class="form-text error-message"
          v-if="fetchError !== null">
          Please check your email or password and try again.
        </small>
        <small data-type="message" v-else></small>

        <small
          data-type="message"
          class="form-text error-message"
          v-if="error.message !== null">
          {{ error.message }}
        </small>

        <small id="forgot-password" class="form-text simple-link">
          <router-link to="/forgot-password">Forgot Password?</router-link>
        </small>
        <br>
        <!-- <small id="create-account" class="form-text simple-link">
          <router-link to="/create-account">Don't have an account yet?</router-link>
        </small> -->
      </div>
    </div>

    <footer-view/>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import { LOGIN } from '@/store/types/actions.type'

import { required, email } from 'vuelidate/lib/validators'

import CreateNavBar from '@/components/common/CreateNavBar'
import Footer from '@/components/common/Footer'
import Loader from '@/components/common/Loader'
import InputComponent from '@/components/form/InputComponent'

import { APIService } from '@/api/APIService'
import { AuthService } from '@/api/AuthService'

const api = new APIService()
const auth = new AuthService()

export default {
  components: {
    CreateNavBar,
    InputComponent,
    Loader,
    'footer-view': Footer
  },
  data() {
    return {
      form: {
        email_address: '',
        password: ''
      },
      pageOrigin: '',
      autoFillEmail: false,
      autoFillPassword: false,
      hasValidInvite: true,
      error: { message: '' },
    }
  },
  validations: {
    form: {
      email_address: { required, email }
    }
  },
  mounted() {
    // do check if there's already someone loggedIn
    if(auth.getUserId()) {
      this.$router.push('/dashboard')
    } else {
      this.pageOrigin = this.$route.query.page_origin
    }

    const token = this.$route.query.t
    if(token) this.verifyToken(token)

  },
  computed: {
    ...mapGetters(['fetchError', 'isRequestInProgress'])
  },
  methods: {
    async verifyToken(token) {
      const tokenParam = { t: token }
      const tokenResponse = await api.verifyInvite(tokenParam)
      // what to do if inviteToken not valid???
      if(tokenResponse.message) {
        this.error.message = 'Invite token is not valid'
        this.hasValidInvite = false
      } else if(tokenResponse.email_address && tokenResponse.password) {
        this.form.email_address = tokenResponse.email_address
        this.form.password = tokenResponse.password
        this.autoFillEmail = true
        this.autoFillPassword = true
        this.hasValidInvite = true
      } else if(tokenResponse.email_address) {
        this.form.email_address = tokenResponse.email_address
        this.autoFillEmail = true
        this.hasValidInvite = true
      } else {
        this.error.message = 'Something went wrong'
        this.hasValidInvite = false
      }
    },
    login() {
      this.error = {}

      const email = this.form.email_address
      this.form.email_address = email.toLowerCase()
      this.request_in_progress = true
      this.postFields()
    },
    postFields() {
      const self = this
      var fields = { ...this.form }

      this.$store.dispatch(LOGIN, fields)
      .then(data => { self.redirectToPage() })
      .catch(err => { self.error.message = err })
    },
    redirectToPage() {
      if(this.pageOrigin === '' || this.pageOrigin === undefined) {
        this.$router.push('/dashboard/passes')
      } else {
        this.$router.push(this.pageOrigin.replace(window.location.origin, ''))
      }
    }
  }
}
</script>

<style scoped>
.container {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  margin-top: 5em;
  padding: 48px;
  border-radius: 4px;
  width: 500px;
  background: white;
  margin-bottom: 64px;
}
.login-form {
  text-align: left;
  margin-top: 36px;
}
.login-form input {
  margin: 0 auto;
}
.login-form .form-group:first-child {
  margin-top: 0;
}
.login-super-container {
  background: #f2f9ff !important;
}

@media (min-width: 650px) and (max-width: 768px) {
  .container {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    margin-top: 5em;
    padding: 35px;
    border-radius: 4px;
    width: 60%;
    background: white;
    margin-bottom: 64px;
  }

  h2 {
    font-size: 45px;
  }
}

@media (min-width: 480px) and (max-width: 649px) {
  .container {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    margin-top: 5em;
    padding: 35px;
    border-radius: 4px;
    width: 70%;
    background: white;
    margin-bottom: 64px;
  }

  h2 {
    font-size: 35px;
  }

  input {
    padding-top: 25px;
    padding-bottom: 25px;
  }
}

@media (max-width: 479px) {
  .nav-container {
    padding-left: 15px;
  }

  .container {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    margin-top: 5em;
    padding: 25px;
    border-radius: 4px;
    width: 85%;
    background: white;
    margin-bottom: 64px;
  }

  h2 {
    font-size: 30px;
  }

  input {
    padding-top: 25px;
    padding-bottom: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/LoginPage.vue